import axios from "../../plugins/modules/axios"

export default {
  namespaced: true,
  state: {
    version: {
      api: "N/A",
      web: window.gconf.version || "N/A"
    }
  },
  mutations: {
    setApiVersion(state,payload) {
      console.log("setApiVersion");
      state.version.api = payload;
    }
  },
  actions: {
    fetchVersionApi({ commit }) {
      axios(`/app/version`).then(res=>{
        console.log("version: ",res.data);
        commit("setApiVersion", res.data);
      });
    }
  }
}
